import { sortingTypes } from "@/common/const";
import { useTableContext } from "@/common/contexts/Table.context";
import CustomTypography from "@/components/Typography/CustomTypography";
import { Tooltip } from "antd";
import { useEffect, useState } from "react";

interface SortComponentProps {
  childKey: string;
  title: string;
  tooltipVariants: string[];
}

export default function SortComponent({
  childKey,
  title,
  tooltipVariants,
}: SortComponentProps) {
  const [fromNewest, setFromNewest] = useState<boolean>(true);
  const { changeFilters, filters, replaceFilter } = useTableContext();

  const generateSortString = () => {
    if (!filters.sort) {
      replaceFilter({ ...filters, sort: {} });
      changeFilters(`sort-${childKey}`, sortingTypes[0]);
      return setFromNewest((state) => !state);
    }
    if (filters?.sort[childKey] === sortingTypes[0]) {
      replaceFilter({ ...filters, sort: {} });
      changeFilters(`sort-${childKey}`, sortingTypes[1]);
      return setFromNewest((state) => !state);
    }

    if (
      !filters?.sort[childKey] ||
      filters?.sort[childKey] === sortingTypes[1]
    ) {
      replaceFilter({ ...filters, sort: {} });
      changeFilters(`sort-${childKey}`, sortingTypes[0]);
      return setFromNewest((state) => !state);
    }
  };

  const tooltip = !fromNewest ? tooltipVariants[0] : tooltipVariants[1];
  useEffect(() => {
    if (!filters?.sort) return setFromNewest(true);
  }, [filters]);
  return (
    <Tooltip title={tooltip}>
      <div
        onClick={generateSortString}
        className="cursor-pointer -mb-7 h-full w-full flex justify-left  text-gray-dim gap-2 items-center"
      >
        <CustomTypography
          as="span"
          case={"uppercase"}
          size={"13px"}
          className="text-nowrap"
          color={"gray"}
        >
          {title}
        </CustomTypography>
        <div className="flex items-center justify-center">
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className="transition"
              d="M6 0L1.5 4.17857V4.875H10.5V4.17857L6 0Z"
              fill={fromNewest ? "#A7A7A7" : "#0E72FF"}
            />
            <path
              className="transition"
              d="M6 12L1.5 7.82143V7.125H10.5V7.82143L6 12Z"
              fill={fromNewest ? "#0E72FF" : "#A7A7A7"}
            />
          </svg>
        </div>
      </div>
    </Tooltip>
  );
}
